import Cookies from "js-cookie";
import { Constants } from "../globals";

export default class PopupContext {
  constructor(props) {
    this.popupList = props?.popupList || []
  }

  addPopup({ id, html, isHide, onConversion, targetElement, targetElementPosition, templateType }) {
    this.popupList.push({ id, html, isHide })
    targetElement.insertAdjacentHTML(targetElementPosition, html)
    const closeButton = document.querySelector(`#${id} .ui-cdp-popup-close-button`)
    if (closeButton) {
      closeButton.onclick = () => this.removeElement(id)
    }
    const dimmed = document.querySelector(`#${id} .ui-cdp-dimmed`)
    if (dimmed) {
      dimmed.onclick = () => this.removeElement(id)
    }
    const todayCloseButton = document.querySelector(`#${id} .ui-cdp-popup-close-today-button`)
    if (todayCloseButton) {
      todayCloseButton.onclick = () => this.removeElement(id, true)
    }
    const linkElement = document.querySelectorAll(`#${id} *[data-cdp-core-element="conversion"]`)
    linkElement.forEach(element => {
      element.onclick = () => {
        onConversion && onConversion()
        this.todayClose(id)
      }
    })
  }

  addPopupThenShow({ id, html, isHide, onConversion, targetElement, targetElementPosition, templateType }) {
    this.addPopup({ id, html, isHide, onConversion, targetElement, targetElementPosition, templateType })
    this.show(id)
  }

  showAll() {
    this.popupList.forEach(modal => this.show(modal.id))
  }

  show(id) {
    this.popupList.filter(modal => modal.id === id).forEach(modal => {
      const element = this.getElementById(id)
      element.style.display = ''
      modal.isHide = false
      this.storeTodayExposure(id)
    })
  }

  hide(id, isTodayClose) {
    this.popupList.filter(modal => modal.id === id).forEach(modal => {
      const element = this.getElementById(id)
      element.style.display = 'none'
      modal.isHide = true
      if (isTodayClose) {
        this.todayClose(id)
      }
    })
  }

  removeElement(id, isTodayClose) {
    this.popupList.filter(modal => modal.id === id).forEach(modal => {
      const element = this.getElementById(id)
      element.style.display = 'none'
      element.remove()
      modal.isHide = true
      if (isTodayClose) {
        this.todayClose(id)
      }
    })
  }

  todayClose(id) {
    const cookie = Cookies.get(Constants.COOKIE_NAME_CAMPAIGN_TODAY_NONE_EXPOSURE_LIST)
    const todayHideCampaignIdList = cookie?.split('|') || []
    todayHideCampaignIdList.push(id)
    Cookies.set(Constants.COOKIE_NAME_CAMPAIGN_TODAY_NONE_EXPOSURE_LIST, [...new Set(todayHideCampaignIdList)].join('|'), {
      expires: this.getExpiryMidnight(),
    })
  }

  storeTodayExposure(id) {
    const cookie = Cookies.get(Constants.COOKIE_NAME_CAMPAIGN_EXPOSURE_LIST)
    const todayExposureCampaignIdList = cookie?.split('|') || []
    todayExposureCampaignIdList.push(id.replace('cdp-popup-', ''))
    Cookies.set(Constants.COOKIE_NAME_CAMPAIGN_EXPOSURE_LIST, [...new Set(todayExposureCampaignIdList)].join('|'), {
      expires: this.getExpiryMidnight(),
    })
  }

  getExpiryMidnight() {
    const date = new Date(Date.now() + (60 * 60 * 24 * 1000))
    return new Date(date.getFullYear(), date.getMonth(), date.getDate())
  }

  getElementById(id) {
    return document.querySelector(`#${id}`)
  }
}
